import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
} from "@ionic/react";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  IconButton,
  List,
  AlertTitle,
  ListItem,
  ListItemText,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  FormLabel,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { baseUrl, config, requestID } from "../../common/utils";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

export type User = {
  accountName: string;
  accountNumber: number;
  activeloans: number;
  area: string;
  bankName: string;
  businessAddress: string;
  bvn: number;
  churchAddress: string;
  dob: string; // Date of birth as a string
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  lga: string;
  middleName: string;
  nextOfKin: string;
  nextOfKinAddress: string;
  nextOfKinPhone: string;
  nextOfKinRelationship: string;
  parish: string;
  password: string; // This should not be displayed or handled in the UI
  pastorName: string;
  pastorPhone: string;
  phone: string;
  province: string;
  residentialAddress: string;
  savingAmount: string;
  securityAnswer1: string;
  securityAnswer2: string;
  securityQuestion1: string;
  securityQuestion2: string;
  status: number;
  titles: string;
  unitHeadName: string;
  unitHeadPhone: string;
  user_id: string;
  zone: string;
};

const schema = yup.object({
  loanAmount: yup.string().required("Loan Amount is required."),
  loanDuration: yup.string().required("Loan Duration is required."),
  loanPurpose: yup.string().required("Loan Purpose is required."),
  // selection: yup.string().required("field is required"), 
  // guarantorID: yup.string().when("selection", {
  //   is: (value: string) => value === "guarantor",
  //   then: (schema) => schema.required("Please Enter Guarantor ID"),
  //   otherwise: (schema) => schema.nullable(),
  // }),
  // guarantorID2: yup.string().when("selection", {
  //   is: (value: string) => value === "guarantor",
  //   then: (schema) => schema.required("Please Enter Guarantor ID 2"),
  //   otherwise: (schema) => schema.nullable(),
  // }),
}).required();

const LoanApplication = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  // const selection = watch("selection");

  const url = "http://localhost/rmfwarri";
  const { name } = useParams<{ name: string }>();
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState<any>(null);
  const [loanAmount, setLoanAmount] = useState<string>("");
  const [loanDuration, setLoanDuration] = useState<string>("");
  const [loanPurpose, setLoanPurpose] = useState<string>("");
  const [request, setRequest] = useState<string>("new");
  const [guarantorID, setGuarantorID] = useState<string>("");
  const [guarantorID2, setGuarantorID2] = useState<string>("");
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");
  const [selection, setSelection] = useState<string>("self");
  const [status, setStatus] = useState({ loading: false, error: false });




  const handleSearch = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setStatus({ loading: true, error: false });
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("searchTerm", searchTerm);

      const response = await axios.post(
        baseUrl() + `users/searchUser`,
        formData,
        config
      );

      const { data } = response.data;
      console.log(data);
      const fetchedResults = data;
      setResults(fetchedResults);
      setStatus({ loading: false, error: false });
    } catch (error) {
      console.error(error);
      setStatus({ loading: false, error: true });
    } finally {
      setStatus({ loading: false, error: false });
    }
  };

  const onShowAlert = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  };

  const applyLoanHandler = async () => {
    try {
      setStatus({ loading: true, error: false });
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("loanAmount", loanAmount);
      formData.append("loanPurpose", loanPurpose);
      formData.append("loanDuration", loanDuration);
      formData.append("user_id", results?.user_id);
      formData.append("guarantorID", guarantorID);
      formData.append("guarantorID2", guarantorID2);
      formData.append("request", request);
      formData.append("loaner", selection);
      const response = await axios.post(
        baseUrl() + "applyloans/loanApplicationStaff",
        formData,
        config
      );
      console.log(response)

      if (response.data.status === true) {
        setAlertMsg(response.data.message);
        onShowAlert();
        setLoanAmount("");
        setLoanDuration("");
        setLoanPurpose("");
        setRequest("");
        setGuarantorID("");
        setGuarantorID2("");
        setResults(null);
        setSearchTerm("");
        setStatus({ loading: false, error: false });
      } else {
        setAlertMsg(response.data.message);
        onShowAlert();
        setStatus({ loading: false, error: true });
      }
    } catch (error) {
      setAlertMsg("An error occurred. Please try again.");
      setStatus({ loading: false, error: true });
      onShowAlert();
    }
  };

  // useEffect(()=>{
  //   turnAround()
  //   return ()=>{}
  // },[])

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Container component="main" maxWidth="md" sx={{ mt: 8, mb: 2 }}>
          <Paper elevation={3} sx={{ padding: 3 }}>
            {showAlert && (
              <Alert severity={status.error ? "error" : "success"}>
                <AlertTitle>{status.error ? "Error " : "Success"}</AlertTitle>
                {alertMsg?.toUpperCase()}
              </Alert>
            )}
            <Typography variant="h5" component="h1" gutterBottom>
              Search User
            </Typography>
            <form onSubmit={handleSearch}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Search by Email or Phone"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                required
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
              >
                {status.loading ? <CircularProgress /> : "Submit"}
              </Button>
            </form>
            {results ? (
              <>
                <List sx={{ mt: 3 }}>
                  <ListItem>
                    <ListItemText
                      primary={`Name: ${results.firstName} ${results.middleName} ${results.lastName}`}
                      secondary={`Phone: ${results.phone}`}
                    />
                  </ListItem>
                </List>
                <Box sx={{ mt: 3 }}>
                  <Typography variant="h6" component="h2" gutterBottom>
                    Additional Information
                  </Typography>
                  <Box sx={{ mb: 2 }}>
                    <TextField
                      fullWidth
                      error={!!errors.loanAmount}
                      {...register("loanAmount")}
                      helperText={errors.loanAmount?.message}
                      type="number"
                      label="Loan Amount"
                      value={loanAmount}
                      onChange={(event) => setLoanAmount(event.target.value)}
                    />
            
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <TextField
                      fullWidth
                      error={!!errors.loanPurpose}
                      label="Purpose of Loan"
                      value={loanPurpose}
                      {...register("loanPurpose")}
                      onChange={(event) => setLoanPurpose(event.target.value)}
                      helperText={errors.loanPurpose?.message}
                    />

                    <Typography color="error">
               
                    </Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <TextField
                      fullWidth
                      type="number"
                      error={!!errors.loanDuration}
                      label="Loan Duration"
                      {...register("loanDuration")}
                      value={loanDuration}
                      onChange={(event) => setLoanDuration(event.target.value)}
                      helperText={errors.loanDuration?.message}
                    />
           
                  </Box>

                  <Box>
                    {" "}
                    <FormControl component="fieldset">
        <RadioGroup
          row
          value={selection}
          onChange={(event) => setSelection(event.target.value)} 
      
        >
          <FormControlLabel value="self" control={<Radio />} label="Self" />
          <FormControlLabel value="guarantor" control={<Radio />} label="Guarantor" />
        </RadioGroup>
      </FormControl>
                    {selection === "guarantor" && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          "& > :not(style)": { mb: 1 },
                        }}
                      >
                        <TextField
                          fullWidth
                          required={selection == "guarantor"}
                          type="text"
                          label="Enter Guarantor ID"
                          error={selection =="guarantor" && guarantorID.length <=0}
                          value={guarantorID}
                          onChange={(event) =>
                            setGuarantorID(event.target.value)
                          }
                          helperText={(selection == "guarantor" && guarantorID.length <=0) && 'please enter a guarantor'}
                        />
                        <TextField
                          fullWidth
                          required={selection == "guarantor"}
                          type="text"
                          error={selection =="guarantor" && guarantorID2.length <=0}
                          label="Enter Guarantor ID"
                          value={guarantorID2}
                          onChange={(event) =>
                            setGuarantorID2(event.target.value)
                          }
                          helperText={(selection =="guarantor" && guarantorID2.length <=0) && 'please enter a guarantor'}
                        />
                      </Box>
                    )}
               
                  </Box>

                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Request Details
                    </Typography>
                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-label="request-details"
                        name="request-details"
                        value={request}
                        onChange={(event) => setRequest(event.target.value)}
                      >
                        <FormControlLabel
                          value="new"
                          control={<Radio />}
                          label="New"
                        />
                        <FormControlLabel
                          value="Repeat"
                          control={<Radio />}
                          label="Repeat"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Box>
                  <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    security="primary"
                    size="large"
                    fullWidth
                    sx={{ mt: 2 }}
                    onClick={handleSubmit(applyLoanHandler)}
                  >
                    {status.loading ? <CircularProgress /> : "Submit Request"}
                  </Button>
                </Box>
              </>
            ) : (
              <List sx={{ mt: 3 }}>
                <ListItem>
                  <ListItemText>No User found</ListItemText>
                </ListItem>
              </List>
            )}
          </Paper>
        </Container>
      </IonContent>
    </IonPage>
  );
};

export default LoanApplication;
